import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  locationId: z.string().optional(),
  status: z.string().optional(),
});

/**
 * @purpose Find a bike in the fleet and check its location and status
 * @primary Bikes table
 * @persona paola-admin-belora, sports-manager-ikos
 */
export const Route = createFileRoute("/app/c/$customerSlug/bikes/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
